/**
 * Mckay-brothers Portal
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import {Inject, Injectable, Optional} from '@angular/core';
import {HttpClient, HttpEvent, HttpHeaders, HttpParams, HttpResponse} from '@angular/common/http';
import {CustomHttpUrlEncodingCodec} from '../encoder';

import {Observable} from 'rxjs';

import {BASE_PATH} from '../variables';
import {Configuration} from '../configuration';
import {User} from '../../models/user';


@Injectable()
export class UserService {

  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();
  protected basePath = 'https://localhost';

  constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
    if (basePath) {
      this.basePath = basePath;
    }
    if (configuration) {
      this.configuration = configuration;
      this.basePath = basePath || configuration.basePath || this.basePath;
    }
  }

  /**
   * Removes the User resource.
   *
   * @param id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteUserItem(id: string, observe?: 'body', reportProgress?: boolean): Observable<any>;

  public deleteUserItem(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;

  public deleteUserItem(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;

  public deleteUserItem(id: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling deleteUserItem.');
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [];

    return this.httpClient.delete<any>(`${this.basePath}/api/users/${encodeURIComponent(String(id))}/delete`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Retrieves the collection of User resources.
   *
   * @param id
   * @param id2
   * @param username
   * @param username2
   * @param companyUniqid
   * @param companyUniqid2
   * @param uniqid
   * @param uniqid2
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getUserCollection(companyUniqid?: string, id?: number, id2?: Array<number>, username?: string, username2?: Array<string>, companyUniqid2?: Array<string>, uniqid?: string, uniqid2?: Array<string>, observe?: 'body', reportProgress?: boolean): Observable<Array<User>>;

  public getUserCollection(companyUniqid?: string, id?: number, id2?: Array<number>, username?: string, username2?: Array<string>, companyUniqid2?: Array<string>, uniqid?: string, uniqid2?: Array<string>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<User>>>;

  public getUserCollection(companyUniqid?: string, id?: number, id2?: Array<number>, username?: string, username2?: Array<string>, companyUniqid2?: Array<string>, uniqid?: string, uniqid2?: Array<string>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<User>>>;

  public getUserCollection(companyUniqid?: string, id?: number, id2?: Array<number>, username?: string, username2?: Array<string>, companyUniqid2?: Array<string>, uniqid?: string, uniqid2?: Array<string>, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

    let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    if (id !== undefined) {
      queryParameters = queryParameters.set('id', <any>id);
    }
    if (id2) {
      id2.forEach((element) => {
        queryParameters = queryParameters.append('id[]', <any>element);
      });
    }
    if (username !== undefined) {
      queryParameters = queryParameters.set('username', <any>username);
    }
    if (username2) {
      username2.forEach((element) => {
        queryParameters = queryParameters.append('username[]', <any>element);
      });
    }
    if (companyUniqid !== undefined) {
      queryParameters = queryParameters.set('company.uniqid', <any>companyUniqid);
    }
    if (companyUniqid2) {
      companyUniqid2.forEach((element) => {
        queryParameters = queryParameters.append('company.uniqid[]', <any>element);
      });
    }
    if (uniqid !== undefined) {
      queryParameters = queryParameters.set('uniqid', <any>uniqid);
    }
    if (uniqid2) {
      uniqid2.forEach((element) => {
        queryParameters = queryParameters.append('uniqid[]', <any>element);
      });
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [];

    return this.httpClient.get<Array<User>>(`${this.basePath}/api/users`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Retrieves a User resource.
   *
   * @param uniqid
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getUserItem(uniqid: string, observe?: 'body', reportProgress?: boolean): Observable<User>;

  public getUserItem(uniqid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<User>>;

  public getUserItem(uniqid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<User>>;

  public getUserItem(uniqid: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
    if (uniqid === null || uniqid === undefined) {
      throw new Error('Required parameter id was null or undefined when calling getUserItem.');
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [];

    return this.httpClient.get<User>(`${this.basePath}/api/users?uniqid=${encodeURIComponent(String(uniqid))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Creates a User resource.
   *
   * @param user The new User resource
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public postUserCollection(user?: {}, observe?: 'body', reportProgress?: boolean): Observable<User>;

  public postUserCollection(user?: {}, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<User>>;

  public postUserCollection(user?: {}, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<User>>;

  public postUserCollection(user?: {}, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [
      'application/json'
    ];
    let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.post<User>(`${this.basePath}/api/users`,
      user,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Replaces the User resource.
   *
   * @param id
   * @param user The updated User resource
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public putUserItem(id: string, user?: any, observe?: 'body', reportProgress?: boolean): Observable<User>;

  public putUserItem(id: string, user?: any, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<User>>;

  public putUserItem(id: string, user?: any, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<User>>;

  public putUserItem(id: string, user?: any, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling putUserItem.');
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [
      'application/json'
    ];
    let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.put<User>(`${this.basePath}/api/users/${encodeURIComponent(String(id))}/edit`,
      user,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param consumes string[] mime-types
   * @return true: consumes contains 'multipart/form-data', false: otherwise
   */
  private canConsumeForm(consumes: string[]): boolean {
    const form = 'multipart/form-data';
    for (let consume of consumes) {
      if (form === consume) {
        return true;
      }
    }
    return false;
  }

}
